/**
 * @generated SignedSource<<0e5299b82870d2ef31facad7b32ab269>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreatePipedriveVerificationKeyInput = {
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type CreatePipedriveVerificationKeyMutation$variables = {
  input: CreatePipedriveVerificationKeyInput;
};
export type CreatePipedriveVerificationKeyMutation$data = {
  readonly createPipedriveVerificationKey: {
    readonly key: string | null;
  } | null;
};
export type CreatePipedriveVerificationKeyMutation = {
  variables: CreatePipedriveVerificationKeyMutation$variables;
  response: CreatePipedriveVerificationKeyMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreatePipedriveVerificationKeyPayload",
    "kind": "LinkedField",
    "name": "createPipedriveVerificationKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreatePipedriveVerificationKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreatePipedriveVerificationKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3cb79c771eb190ec43760d600d25ea70",
    "id": null,
    "metadata": {},
    "name": "CreatePipedriveVerificationKeyMutation",
    "operationKind": "mutation",
    "text": "mutation CreatePipedriveVerificationKeyMutation(\n  $input: CreatePipedriveVerificationKeyInput!\n) {\n  createPipedriveVerificationKey(input: $input) {\n    key\n  }\n}\n"
  }
};
})();

(node as any).hash = "16ccc8a67cb0d96979ba4d6ad0affe32";

export default node;
